import React, { useState } from 'react'

import { Box, Typography, Button, Chip } from '@material-ui/core'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { useHistory, useParams } from 'react-router-dom'
import { reverse } from 'named-urls'

import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from 'components/Table'
import { MenuButton, Permitted } from 'components'
import { routes } from 'Routes'

import DialogChangeStatus from '../DialogChangeStatus'
import DialogDestroy from '../DialogDestroy'

import constants from 'constants/index'

import useStyles from '../../styles'

const TableRowCommitteeUser = ({
  committeeUser,
  setDialogOpen,
  setOpenDestroy,
  setCommitteeUser,
  setActive,
  params,
  ...rest
}) => {
  const history = useHistory()
  const classes = useStyles()

  const handleRedirectEdit = ({ committeeId, committeeUserId }) => {
    history.push(
      reverse(routes.committees.committeeUserEdit, {
        committeeId,
        committeeUserId,
      }),
    )
  }

  const handleOpenDialog = (active, committeeUserId) => {
    setActive(active)
    setCommitteeUser(committeeUserId)
    setDialogOpen(true)
  }

  const handleDestroy = (committeeUserId) => {
    setCommitteeUser(committeeUserId)
    setOpenDestroy(true)
  }

  return (
    <TableRow {...rest}>
      <TableCell>
        <Typography variant="body1">{committeeUser?.user?.id}</Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body1">{committeeUser?.user?.name}</Typography>
      </TableCell>
      <TableCell>
        <Chip
          size="small"
          className={classes[committeeUser?.status]}
          label={constants.committees.STATUSES[committeeUser?.status]}
        />
      </TableCell>
      <TableCell>
        <Typography variant="body1">
          {committeeUser?.userProfile?.name}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body1">
          {committeeUser?.committeeRole?.name}
        </Typography>
      </TableCell>
      <Permitted tag={constants.permissions.COMMITTEES.MANAGE}>
        <TableCell align="right">
          <MenuButton>
            <Permitted tag={constants.permissions.COMMITTEES.MANAGE}>
              <Button
                color="secondary"
                onClick={() =>
                  handleRedirectEdit({
                    committeeId: params?.committeeId,
                    committeeUserId: committeeUser?.id,
                  })
                }
                fullWidth
                size="small"
              >
                Editar
              </Button>
            </Permitted>
            <Permitted tag={constants.permissions.COMMITTEES.MANAGE}>
              <Button
                color="secondary"
                onClick={() =>
                  handleOpenDialog(
                    committeeUser?.status ===
                      constants.committees.ACTIVE_STATUS,
                    committeeUser?.id,
                  )
                }
                fullWidth
                size="small"
              >
                {committeeUser?.status === constants.committees.ACTIVE_STATUS
                  ? constants.committees.INACTIVE_STATUS_LABEL
                  : constants.committees.ACTIVE_STATUS_LABEL}
              </Button>
            </Permitted>
            <Permitted tag={constants.permissions.COMMITTEES.MANAGE}>
              <Button
                color="secondary"
                onClick={() => handleDestroy(committeeUser?.id)}
                fullWidth
                size="small"
              >
                Excluir
              </Button>
            </Permitted>
          </MenuButton>
        </TableCell>
      </Permitted>
    </TableRow>
  )
}

const CommitteeUsersTable = ({ committeeUsers, isLoading, onEvent }) => {
  const [committeeUser, setCommitteeUser] = useState()
  const [active, setActive] = useState()
  const [dialogChangeStatus, setDialogChangeStatus] = useState(false)
  const [dialogDestroy, setDialogDestroy] = useState(false)
  const params = useParams()

  return (
    <Box width="100%">
      <PerfectScrollbar
        options={{ wheelPropagation: false, useBothWheelAxes: true }}
      >
        <Table
          size="small"
          emptyMessage="Nenhum usuário de comitê encontrado"
          isLoading={isLoading}
          noWrap
        >
          <TableHead>
            <TableRow>
              <TableCell width="20%">Identificador</TableCell>
              <TableCell width="20%">Usuário</TableCell>
              <TableCell width="20%">Status</TableCell>
              <TableCell width="20%">Perfil</TableCell>
              <TableCell width="20%">Cargo no comitê</TableCell>
              <Permitted tag={constants.permissions.COMMITTEES.MANAGE}>
                <TableCell width="20%" align="right">
                  Ações
                </TableCell>
              </Permitted>
            </TableRow>
          </TableHead>

          <TableBody>
            {committeeUsers &&
              committeeUsers.map((committeeUser) => (
                <TableRowCommitteeUser
                  committeeUser={committeeUser}
                  key={committeeUser?.id}
                  setCommitteeUser={setCommitteeUser}
                  setActive={setActive}
                  setDialogOpen={setDialogChangeStatus}
                  setOpenDestroy={setDialogDestroy}
                  params={params}
                  hover
                />
              ))}
          </TableBody>
        </Table>
      </PerfectScrollbar>
      {committeeUsers && (
        <>
          <DialogChangeStatus
            active={active}
            committeeId={params?.committeeId}
            committeeUserId={committeeUser}
            open={dialogChangeStatus}
            setOpen={setDialogChangeStatus}
            onEvent={onEvent}
          />
          <DialogDestroy
            committeeId={params?.committeeId}
            committeeUserId={committeeUser}
            open={dialogDestroy}
            setOpen={setDialogDestroy}
            onEvent={onEvent}
          />
        </>
      )}
    </Box>
  )
}

export default CommitteeUsersTable
